import { Protected } from "@/components/layout/Protected";
import { Box, Grid, Container, Typography, IconButton, SelectChangeEvent, Autocomplete, Button, } from '@mui/material'
import { useState } from "react";
import { Props } from "../LuQuoteBook.type"
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import '../LuQuoteBook_styles.css'
import TextField from '@mui/material/TextField';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LoadingButton from '@mui/lab/LoadingButton';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { AddCircle } from "@mui/icons-material";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import BookIcon from '@mui/icons-material/Book';

interface Column {
   id: 'numero' | 'fecha' | 'hora'|'observacion'|'situacion' ;
   label: string;
   minWidth?: number;
   align?: 'right';
   format?: (value: number) => string;
}

const columns: readonly Column[] = [
   { id: 'numero', label: 'Número', minWidth: 10 },
   { id: 'fecha', label: 'Fecha', minWidth: 100 },
   { id: 'hora', label: 'Hora', minWidth: 50 },
   { id: 'observacion', label: 'Observación', minWidth: 100 },
];

interface Data {
   numero: string;
   fecha: string;
   hora: string;
   observacion: string;
}

function createData(
   numero: string,
   fecha: string,
   hora: string,
   observacion: string,
): Data {
   return { numero, fecha, hora, observacion };
}

const rowsData = [
   createData('1', '02/05/2022', '08:00 ', 'Observación'),
   createData('2', '02/05/2022', '08:00 ', 'Observación'),
   createData('3', '02/05/2022', '08:00 ', 'Observación'),
   createData('4', '02/05/2022', '08:00 ', 'Observación'),
   createData('5', '02/05/2022', '08:00 ', 'Observación'),
]


export const DataCotizacionState: React.FC<Props> = (props: Props): JSX.Element => {
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [value, setValue] = useState('');
   const [loading, setLoading] = useState(false);
   const [ejecutivoComercial, setEjecutivoComercial] = useState('');
   const [estado, setEstado] = useState('');


   const handleChangeEjecutivoComercial = (event: SelectChangeEvent) => {
      setEjecutivoComercial(event.target.value);
   };
   const handleChangeEstado = (event: SelectChangeEvent) => {
      setEstado(event.target.value);
   };
   function handleClick() {
      setLoading(true);
   }

   const handleChangePage = (event: unknown, newPage: number) => {
      setPage(newPage);
   };

   const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
   };

   const estadoActual=[
      {label:'No Adjudicada',value:'Enviado'},
      {label:'Adjudicada',value:'Adjudicada'},
      {label:'Anulada',value:'No Adjudicada'},
   ]
   const estadoPosible=[
      {label:'Descartada',value:'Enviado'},
      {label:'No descartada',value:'Adjudicada'},
      {label:'Probable',value:'No Adjudicada'},
   ]
   return (
         <Container maxWidth='xl'>   
           <Grid item xs={12} md={12} >
                  <Box>
                     <Typography variant='h6' component='h1' gutterBottom className="tittle">
                        COTIZACION N° 864 - Tipo 777
                     </Typography>
                  </Box>
                  <Box>
                     <Typography variant='subtitle2'  gutterBottom >
                     WORKFLOW                        
                      </Typography>
                  </Box>
            </Grid>   

            <Grid container spacing={2} >
               <Grid item xs={12} md={4}>
                  <Autocomplete
                     disablePortal
                     size='small'
                     id="combo-box-demo"
                     options={estadoPosible}
                     renderInput={(params) => <TextField {...params} label="Estado Posible" />}
                  />
               </Grid>
               <Grid item xs={12} md={4}>
                  <Autocomplete
                     disablePortal
                     size='small'
                     id="combo-box-demo"
                     options={estadoActual}
                     renderInput={(params) => <TextField {...params} label="Estado Actual" />}
                  />
               </Grid>
               <Grid item xs={12} md={4}>
                  <TextField
                     label="Observacion"
                     id="outlined-size-small"
                     size="small"
                     fullWidth
                  />
               </Grid>
            </Grid>  

               <Grid item container
                           xs={12}
                           mt={2}
                        justifyContent='center'
                        >
                              <Grid item>
                                 <Button
                                    type='submit'
                                    variant='contained'
                                    
                                    // onClick={handleSubmit}
                                    // disabled={loading}
                                    disableElevation
                                    // component={Link} to={ROUTE_EV_QUOTE_BOOK_RESUME}
                                    className='btn_next'
                                 >
                                          <span>ACTUALIZAR</span>
                                 </Button>
                              </Grid>
               </Grid>   
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
               <TableContainer sx={{ maxHeight: 440 }}>
                  <Table stickyHeader aria-label="sticky table">
                     <TableHead>
                        <TableRow>
                           {columns.map((column) => (
                              <TableCell
                              
                                 key={column.id}
                                 align={column.align}
                                 style={{ minWidth: column.minWidth }}
                              >
                                 {column.label}
                              </TableCell>
                           ))}
                           <TableCell>
                              Opciones
                           </TableCell>
                        </TableRow>
                     </TableHead>
                     <TableBody>
                        {rowsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                           return (
                              <TableRow hover role="checkbox" tabIndex={-1} key={row.numero}>
                                 {columns.map((column) => {
                                    const value = row[column.id];
                                    return (
                                       <TableCell key={column.id} align={column.align}>
                                          {column.format && typeof value === 'number'
                                             ? column.format(value)
                                             : value}
                                       </TableCell>
                                    );
                                 })}
                                 <TableCell>
                                    <IconButton>
                                       
                                          <BookIcon
                                          style={{ fontSize:'20px' }}
                                          // onClick={handleOpen}
                                       />
                                    </IconButton>
                                 </TableCell>
                              </TableRow>
                           );
                        })}

                     </TableBody>
                  </Table>
               </TableContainer>
               <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={rowsData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
               />
            </Paper>

         </Container>
   );
};

